import React from 'react';
import { Link } from 'react-router-dom';
import { linksFor, useSiteConfig } from '../context/SiteConfigContext';
import SiteLinkIcon from './SiteLinkIcon';
import './FloatingHelp.css';
export default function FloatingHelp() {
  const link = linksFor(useSiteConfig(), 'floating')[0];
  if (!link) return null;
  let internal = false;
  try { const url = new URL(link.url); internal = url.pathname === '/help' && (url.origin === window.location.origin || url.hostname === 'jlastore.com'); } catch (_) { return null; }
  const props = { className: 'store-floating-help', 'aria-label': link.label, title: link.label };
  return internal ? <Link {...props} to="/help"><SiteLinkIcon type={link.type} /></Link>
    : <a {...props} href={link.url} target="_blank" rel="noopener noreferrer"><SiteLinkIcon type={link.type} /></a>;
}
